import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Linkedin, Twitter } from 'lucide-react';
import IrisLogo from './IrisLogo';

const Footer = () => {
  const footerLinks = {
    products: [
      { name: 'AI-Enhanced XDR', href: '/products#xdr' },
      { name: 'AI BAS', href: '/products#bas' },
      { name: 'ML-Driven CTEM', href: '/products#ctem' },
      { name: 'AI-Led EASM + TPRM', href: '/products#easm' },
      { name: 'Autonomous SOC', href: '/products#soc' },
    ],
    industries: [
      { name: 'BFSI', href: '/industries#bfsi' },
      { name: 'Healthcare', href: '/industries#healthcare' },
      { name: 'Government', href: '/industries#government' },
      { name: 'Critical Infrastructure', href: '/industries#infrastructure' },
      { name: 'Technology', href: '/industries#technology' },
    ],
    company: [
      { name: 'About Us', href: '/about' },
      { name: 'Investors', href: '/investors' },
      { name: 'Careers', href: '/careers' },
      { name: 'Contact', href: '/contact' },
    ],
    resources: [
      { name: 'Blog', href: '/resources' },
      { name: 'Whitepapers', href: '/resources#whitepapers' },
      { name: 'Case Studies', href: '/resources#case-studies' },
      { name: 'Documentation', href: '/resources#docs' },
    ],
  };

  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-section">
            <div className="footer-logo">
              <IrisLogo width="36" height="36" className="footer-logo-svg" />
              <span className="footer-logo-text">IrisTechLabs</span>
            </div>
            <p className="footer-tagline">
              AI-Powered Security for the Next Decade
            </p>
            <div className="footer-contact">
              <div className="contact-item">
                <Mail size={16} />
                <span>contact@iristechlabs.com</span>
              </div>
              <div className="contact-item">
                <MapPin size={16} />
                <span>Bangalore, India</span>
              </div>
            </div>
            <div className="footer-social">
              <a href="#" className="social-link" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
              <a href="#" className="social-link" aria-label="Twitter">
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Products */}
          <div className="footer-section">
            <h3 className="footer-heading">Products</h3>
            <ul className="footer-links">
              {footerLinks.products.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="footer-link">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Industries */}
          <div className="footer-section">
            <h3 className="footer-heading">Industries</h3>
            <ul className="footer-links">
              {footerLinks.industries.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="footer-link">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className="footer-section">
            <h3 className="footer-heading">Company</h3>
            <ul className="footer-links">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="footer-link">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div className="footer-section">
            <h3 className="footer-heading">Resources</h3>
            <ul className="footer-links">
              {footerLinks.resources.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="footer-link">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              © {new Date().getFullYear()} IrisTechLabs. All rights reserved.
            </p>
            <div className="footer-legal">
              <Link to="/privacy" className="legal-link">Privacy Policy</Link>
              <Link to="/terms" className="legal-link">Terms of Service</Link>
              <Link to="/security" className="legal-link">Security</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
